module.exports = __webpack_public_path__ + "img/Weapon_280.bfa9108b.png";